import { createSlice } from "@reduxjs/toolkit";

const sandhayaEditSlice = createSlice({
  name: "sandhayaEdit",
  initialState: {
    isSandhayaEditOpen: false,
  },
  reducers: {
    toogleSandhayaEdit: (state) => {
      state.isSandhayaEditOpen = !state.isSandhayaEditOpen;
    },
  },
});

export const { toogleSandhayaEdit } = sandhayaEditSlice.actions;
export default sandhayaEditSlice.reducer;